const actionTypes = {
    SELECTED_SEASON_ID: "SELECTED_SEASON_ID"
  };
  
  export default actionTypes;
  